<template>
  <div class="section section_big-padding-bottom section_white">
    <div class="max-width">
      <div class="doc">
        <div class="doc__grid">
          <div class="doc__about">
            <h2 class="section__title">Guidance for Every Step</h2>
            <div class="section__text">Get step-by-step setup guidance — plus 24/7 support with 15-minute response times, any day of the week, even during your trial.</div>
            <div class="section__buttons">
              <router-link :to="docLink" class="button" target="_blank">
                View Documentation
                <svg width="15" height="14" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M9.00767 2.3999L13.6689 7.061M13.6689 7.061L9.08285 11.6471M13.6689 7.061L1.40002 7.061"
                        stroke="white" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
              </router-link>
            </div>
          </div>

          <div class="doc__pic">
            <div class="doc__pic-main">
              <img :src="imgMain" :srcset="imgSet" loading="lazy" alt="">
            </div>
            <div class="doc__pic-bg">
              <img loading="lazy" src="/assets/imgs/doc-bg.webp" alt="">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DocView',
  props: {
    docLink: { type: String, required: true },
    imgMain: { type: String, required: true },
    imgSet: { type: String, required: false },
  }
}
</script>

<style lang="scss">
.doc {
  &__grid {
    display:flex;
    gap:2rem;
    align-items:center;

    @include md {
      gap:3rem;
      flex-direction:column;
    }
  }

  &__about {
    flex:auto;

    .section__title {
      font-size:2.5rem;

      @include xs {
        font-size:2rem;
      }
    }

    .section__text {
      max-width:100%;
    }
  }

  &__pic {
    flex:none;
    width:49%;
    aspect-ratio: 1;
    display:flex;
    align-items:center;
    justify-content:flex-end;
    position:relative;
    overflow:hidden;
    border-radius:12px;
    box-shadow:inset 0 0 0 1px rgba(138,138,138,.1);

    @include md {
      width:100%;
      aspect-ratio: initial;
      padding:3rem 0 3rem 3rem;
    }

    @include xs {
      padding:2rem 0 2rem 2rem;
    }

    &-main {
      position:relative;
      z-index:2;

      img {
        filter:drop-shadow(0 0 21px rgba(127, 127, 127, 0.1));
      }
    }

    &-bg {
      position:absolute;
      left:0;
      top:0;
      width:100%;
      height:100%;

      img {
        width:100%;
        height:100%;
        object-fit:cover;
      }
    }
  }
}
</style>
